import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; // Import useLocation
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../Redux/Actions/userActions";

const Header = ({ isHome = false, isScrolled = true }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation(); // Get current location
  
  // For debugging
  useEffect(() => {
    console.log("Header props:", { isHome, isScrolled });
  }, [isHome, isScrolled]);

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  // Function to check if a link is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = "+254746003525"; 
    const message = "Hello, I would like to know more about your art!";
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, "_blank");
  };

  const logoutHandler = () => {
    dispatch(logout());
  };

  const logoSrc = "/images/logo.png";

  // Determine the header class based on if we're on homepage and scroll position
  const headerClass = isHome ? (isScrolled ? "black-header" : "transparent-header") : "black-header";

  const navLinkClass = "nav-link-white";
  const buttonLinkClass = "btn-link-white";
  const cartIconClass = "cart-icon-white";
  const menuButtonColor = "menu-button-white";

  // Generate user initials for avatar
  const getUserInitials = () => {
    if (!userInfo || !userInfo.name) return "?";
    return userInfo.name
      .split(" ")
      .map(name => name.charAt(0))
      .join("")
      .toUpperCase()
      .substring(0, 2);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className={headerClass}>
      {/* MOBILE HEADER */}
      <div className="mobile-header flex">
        <div className="container">
          <div className="row">
            <div className="col-6 d-flex align-items-center">
              <Link className="navbar-brand" to="/">
                <img alt="logo" src={logoSrc} />
              </Link>
            </div>
            <div className="col-6 d-flex align-items-center justify-content-end">
              <Link to="/cart" className={`cart-mobile-icon ${cartIconClass}`}>
                <i className="fas fa-shopping-bag"></i>
                <span className="mobile-badge">{cartItems.length}</span>
              </Link>
              <button className={`menu-button ${menuButtonColor}`} onClick={toggleMenu}>
                <i className="fas fa-bars"></i>
              </button>
            </div>
          </div>
        </div>
        {/* Mobile Menu */}
        <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
          <div className="mobile-menu-overlay" onClick={toggleMenu}></div>
          <div className="mobile-menu-content">
            <button className="close-button" onClick={toggleMenu}>
              <i className="fas fa-times"></i>
            </button>
            <nav>
              <ul className="nav-list">
                <li className="nav-item">
                  <Link 
                    className={`mobile-nav-link ${navLinkClass} ${isActive('/') ? 'active' : ''}`} 
                    to="/" 
                    onClick={toggleMenu}
                  >
                    HOME
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    className={`mobile-nav-link ${navLinkClass} ${isActive('/prints') ? 'active' : ''}`} 
                    to="/prints" 
                    onClick={toggleMenu}
                  >
                    PRINTS
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    className={`mobile-nav-link ${navLinkClass} ${isActive('/commissions') ? 'active' : ''}`} 
                    to="/commissions" 
                    onClick={toggleMenu}
                  >
                    COMMISSIONS
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    className={`mobile-nav-link ${navLinkClass} ${isActive('/events') ? 'active' : ''}`} 
                    to="/events" 
                    onClick={toggleMenu}
                  >
                    EVENTS
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    className={`mobile-nav-link ${navLinkClass} ${isActive('/merchandise') ? 'active' : ''}`} 
                    to="/merchandise" 
                    onClick={toggleMenu}
                  >
                    MERCHANDISE
                  </Link>
                </li>
                <li className="nav-item">
                  <Link 
                    className={`mobile-nav-link ${navLinkClass} ${isActive('/about') ? 'active' : ''}`} 
                    to="/about" 
                    onClick={toggleMenu}
                  >
                    ABOUT
                  </Link>
                </li>
                {userInfo ? (
                  <>
                    <li className="nav-item">
                      <Link 
                        className={`mobile-nav-link ${isActive('/profile') ? 'active' : ''}`} 
                        to="/profile" 
                        onClick={toggleMenu}
                      >
                        <i className="fas fa-user-circle mr-2"></i>
                        MY ACCOUNT
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link 
                        className="mobile-nav-link" 
                        to="#" 
                        onClick={() => { logoutHandler(); toggleMenu(); }}
                      >
                        <i className="fas fa-sign-out-alt mr-2"></i>
                        LOGOUT
                      </Link>
                    </li>
                  </>
                ) : (
                  <>
                    <li className="nav-item">
                      <Link 
                        className={`mobile-nav-link ${buttonLinkClass} ${isActive('/register') ? 'active' : ''}`} 
                        to="/register" 
                        onClick={toggleMenu}
                      >
                        <i className="fas fa-user-plus mr-2"></i>
                        REGISTER
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link 
                        className={`mobile-nav-link ${buttonLinkClass} ${isActive('/login') ? 'active' : ''}`} 
                        to="/login" 
                        onClick={toggleMenu}
                      >
                        <i className="fas fa-sign-in-alt mr-2"></i>
                        LOGIN
                      </Link>
                    </li>
                    <div className="mobile-social-icons">
                      <a
                        href="https://www.facebook.com/kelvin.wamae.988"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon facebook"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a
                        href="https://instagram.com/wamae_k"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon instagram"
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                      <a
                        href="https://twitter.com/Wamae4art"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon twitter"
                      >
                        <i className="fab fa-twitter"></i>
                      </a>
                      <a
                        href="https://tiktok.com/@wamae_k"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon tiktok"
                      >
                        <i className="fab fa-tiktok"></i>
                      </a>
                      <a
                        href="https://www.youtube.com/@wamae_arts"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon youtube"
                      >
                        <i className="fab fa-youtube"></i>
                      </a>
                      <button className="social-icon whatsapp" onClick={handleWhatsAppClick}>
                        <i className="fab fa-whatsapp"></i>
                      </button>
                    </div>
                  </>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* PC HEADER */}
      <div className="pc-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="d-flex justify-content-between align-items-center w-100">
              
              <div className="navbar-brand-container">
                <Link className="navbar-brand" to="/">
                  <img alt="logo" src={logoSrc} />
                </Link>
              </div>
              
              {/* Navigation Links */}
              <nav className="main-nav">
                <ul className="nav">
                  <li className="nav-item">
                    <Link className={`nav-link ${navLinkClass} ${isActive('/') ? 'active' : ''}`} to="/">HOME</Link>
                  </li>
                  <li className="nav-item">
                    <Link className={`nav-link ${navLinkClass} ${isActive('/prints') ? 'active' : ''}`} to="/prints">PRINTS</Link>
                  </li>
                  <li className="nav-item">
                    <Link className={`nav-link ${navLinkClass} ${isActive('/commissions') ? 'active' : ''}`} to="/commissions">COMMISSIONS</Link>
                  </li>
                  <li className="nav-item">
                    <Link className={`nav-link ${navLinkClass} ${isActive('/events') ? 'active' : ''}`} to="/events">EVENTS</Link>
                  </li>
                  <li className="nav-item">
                    <Link className={`nav-link ${navLinkClass} ${isActive('/merchandise') ? 'active' : ''}`} to="/merchandise">MERCHANDISE</Link>
                  </li>
                  <li className="nav-item">
                    <Link className={`nav-link ${navLinkClass} ${isActive('/about') ? 'active' : ''}`} to="/about">ABOUT</Link>
                  </li>
                </ul>
              </nav>
              
              {/* User Account & Cart - UPDATED SECTION */}
              <div className="user-actions d-flex align-items-center">
                {userInfo ? (
                  <div className="btn-group mr-3">
                    <button
                      type="button"
                      className="name-button dropdown-toggle d-flex align-items-center"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ color: '#ffffff', backgroundColor: 'transparent', border: 'none' }}
                    >
                      <div className="user-avatar mr-2" style={{
                        backgroundColor: '#d4af37',
                        color: '#000',
                        borderRadius: '50%',
                        width: '30px',
                        height: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        marginRight: '8px'
                      }}>
                        {getUserInitials()}
                      </div>
                      <span>Hi, {userInfo.name.split(' ')[0]}</span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                      <Link className={`dropdown-item ${isActive('/profile') ? 'active' : ''}`} to="/profile">
                        <i className="fas fa-user-circle mr-2"></i> My Account
                      </Link>
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={logoutHandler}
                      >
                        <i className="fas fa-sign-out-alt mr-2"></i> Logout
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div className="btn-group mr-3">
                    <button
                      type="button"
                      className="name-button dropdown-toggle d-flex align-items-center"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ color: '#ffffff', backgroundColor: 'transparent', border: 'none' }}
                    >
                      <div className="user-avatar mr-2" style={{
                        backgroundColor: '#333',
                        color: '#fff',
                        borderRadius: '50%',
                        width: '30px',
                        height: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className="fas fa-user"></i>
                      </div>
                      <span></span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                      <Link className={`dropdown-item ${isActive('/login') ? 'active' : ''}`} to="/login">
                        <i className="fas fa-sign-in-alt mr-2"></i> Login
                      </Link>
                      <Link className={`dropdown-item ${isActive('/register') ? 'active' : ''}`} to="/register">
                        <i className="fas fa-user-plus mr-2"></i> Register
                      </Link>
                    </div>
                  </div>
                )}
                <Link to="/cart" className={`cart-icon ${cartIconClass} ${isActive('/cart') ? 'active' : ''}`}>
                  <i className="fas fa-shopping-bag"></i>
                  <span className="badge">{cartItems.length}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;